import React from 'react'

//STYLES
import './Contact.css'
import { useData } from '../../../hooks/useData'
import ContactCard from '../../../components/ui/ContactCard'

export default function Contact() {

    const {data: contactList} = useData('CONTACTS')

    return (
        <div className='contact-page page-container shadowed'>
            <h1>Contact</h1>
            <p>En cas de soucis, n'héshitez pas à contacter l'une des personnes suivantes :</p>
            { contactList && contactList.map( (contact) => (
                <ContactCard 
                    key={contact.id}
                    contact={contact}
                />
            ))}
        </div>
  )
}
